export const CODES = new Map([
  [0, 'Clear Sky'],
  [1, 'Mainly Clear'],
  [2, 'Partly Cloudy'],
  [3, 'Overcast'],
  [45, 'Fog'],
  [48, 'Depositing Rime fog'],
  [51, 'Light Drizzle'],
  [53, 'Moderate Drizzle'],
  [55, 'Dense Drizzle'],
  [56, 'Light Freezing Drizzle'],
  [57, 'Dense Freezing Drizzle'],
  [61, 'Slight Rain'],
  [63, 'Moderate Rain'],
  [65, 'Heavy Rain'],
  [66, 'Light Freezing Rain'],
  [67, 'Heavy Freezing Rain'],
  [71, 'Slight Snowfall'],
  [73, 'Moderate Snowfall'],
  [75, 'Heavy Snowfall'],
  [77, 'Snow Grains'],
  [80, 'Slight Rain Showers'],
  [81, 'Moderate Rain Showers'],
  [82, 'Violent Rain Showers'],
  [85, 'Slight Snow Showers'],
  [86, 'Heavy Snow Showers'],
  [95, 'Moderate Thunderstorm'],
  [96, 'Thunderstorm with Slight Hail'],
  [99, 'Thunderstorm with Heavy Hail'],
]);
